module.exports = __webpack_public_path__ + "static/media/timelapse_18.248ffd76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_18.jpg
// module id = 976
// module chunks = 0